export default {
    // 获取前一个路由
    getPreviousRoute:(state) => () => {
        return state.previousRoute;
    }

}